import { makeStyles, tokens } from '@fluentui/react-components';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

const useStyles = makeStyles({
  layout: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
  },
  mainContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    padding: tokens.spacingVerticalXXL,
    overflowY: 'auto',
  },
  content: {
    maxWidth: '1400px',
    margin: '0 auto',
    width: '100%',
  },
  // DEV/preview environment banner. Renders only when import.meta.env.DEV
  // is true (Vite dev server) — never visible in production builds.
  // Helps avoid the "wait, is this prod?" footgun when staring at the
  // wizard for hours and tabs blur together.
  devBanner: {
    backgroundColor: '#fef3c7', // warm yellow
    color: '#78350f',
    padding: '6px 16px',
    fontSize: '12px',
    fontWeight: 600,
    textAlign: 'center',
    borderBottom: '1px solid #fbbf24',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
  },
});

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  const styles = useStyles();
  const isDev = import.meta.env.DEV;

  return (
    <div className={styles.layout}>
      <Sidebar />
      <div className={styles.mainContainer}>
        {isDev && (
          <div className={styles.devBanner}>
            ⚠ Local development build · changes you make here run only on your machine
          </div>
        )}
        <Header />
        <main className={styles.main}>
          <div className={styles.content}>{children}</div>
        </main>
      </div>
    </div>
  );
}
